import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import {
  formateDateTime,
  formateDateWithTime,
  getAlphabets,
  romanize,
} from "../../../utils/commonFunctions";
import { CircularAvatar, DropDown } from "../../commons";
import UpdatedByAndUpdatedAt from "../../commons/CommonUpdatedByAndUpdatedAt";
import { PlusIconCircle, UploadNewIcon } from "../../../assets/images";
import { PaperClipIcon } from "../../Icon";
import "./style.scss";
import { FlattenedProcedureType } from "../../../commonTypes/jobsType";
import { STATUS_OF_PROCEDURE } from "../../../constant/jobs";
import { LoginResponseType } from "../../../redux/auth/authTypes";

type AppProps = {
  data: FlattenedProcedureType[] | [];
  header: TableHeadersType[];
  isLocked:boolean;
  loginData: LoginResponseType;
  handleDropDownChange: (
    data: TableHeadersType,
    procedureId: string,
    index: number
  ) => void;
  handleCommentChange: (e: any, index: number) => void;
  handleSubmitComment: (id: string) => void;
  handleApprovalChange: (id: string, index: number) => void;
  handleFilePreviewData: (id: number) => void;
  handleUploadSingleProcedureFile: (id: number, procedureId: string) => void;
  setShowFileUploadModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowImagePreview: React.Dispatch<React.SetStateAction<boolean>>;
};

const AllOpenJobChecklistTableData = ({
  data,
  header,
  loginData,
  isLocked,
  handleDropDownChange,
  handleCommentChange,
  handleApprovalChange,
  handleSubmitComment,
  handleFilePreviewData,
  handleUploadSingleProcedureFile
}: AppProps) => {
  
  function capitalizeFirstLetterOfEachWord(str:string) {
    return str
      ?.split(' ')
      ?.map(word => word.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ');
  }

  return (
    <>
      {data?.map((procedure: any, index: number) => {
        let isApproved = procedure?.details?.approver_details?.find(
          (item: any) => item?.user_id === loginData?.user_id
        );

        let finalRow = header?.map((singleHeader: TableHeadersType) => {
          if (singleHeader?.value === "title") {
            return (
              <td
                colSpan={(procedure?.key == "procedure" && procedure?.children) ? header?.length : 1 }
                style={{
                  paddingLeft: `${
                    procedure?.key === "procedure"
                      ? "1rem"
                      : procedure?.key === "sub"
                      ? "2rem"
                      : procedure?.key === "firstLevel"
                      ? "3rem"
                      : procedure?.key === "secondLevel"
                      ? "4rem"
                      : "5rem"
                  }`,
                }}
              >
                <div>
                  <div className="number_text">
                    {procedure?.key !== "procedure" ? (
                      <div className="count_circle">
                        {procedure?.key === "sub"
                          ? procedure.count
                          : procedure?.key === "firstLevel"
                          ? getAlphabets(procedure.count)?.toUpperCase()
                          : procedure?.key === "secondLevel"
                          ? romanize(procedure.count)
                          : null}{" "}
                      </div>
                    ) : null}
                    <span
                      className={
                        procedure?.key === "procedure"
                          ? "all_open_checklist_procedure"
                          : "simple_text"
                      }
                    >
                      {procedure?.details?.procedure_description}
                    </span>
                  </div>
                </div>
              </td>
            );
          } else if (
            singleHeader?.value === "comment" 
          ) {
            return (
              (procedure?.key === "procedure" && procedure?.children) ? null : <td>
                {!procedure?.children  ? <div>
                  <div style={{ width: "140px" }}>
                    <DropDown
                      options={STATUS_OF_PROCEDURE}
                      disabled={isLocked}
                      value={procedure?.details?.status ? {
                        label: capitalizeFirstLetterOfEachWord(procedure?.details?.status),
                        value: procedure?.details?.status,
                      } : {label:"Select...",value:null}}
                      handleChange={(data: TableHeadersType) =>
                        handleDropDownChange(data, procedure?._id, index)
                      }
                    />
                  </div>

                  {(procedure?.details?.status==="yes" || procedure?.details?.status==="no") ? <div className="mt-2">
                    <textarea
                      className="form-control"
                      name="comment"
                      placeholder="comment..."
                      disabled={isLocked}
                      style={{
                        height: "55px",
                        resize: "none",
                        width: "200px",
                      }}
                      onChange={(e: any) => handleCommentChange(e, index)}
                      onBlur={() => handleSubmitComment(procedure?._id)}
                      value={procedure?.details?.comments}
                    />
                  </div> : null}
                </div> : null}
              </td>
            );
          } else if (
            singleHeader?.value === "last_modified" 
          ) {
            return (
              (procedure?.key === "procedure" && procedure?.children) ? null : <td>
                {(!procedure?.children && !!procedure?.details?.updated_at) ? (
                  <UpdatedByAndUpdatedAt
                    firstName={procedure?.details?.updated_by?.first_name}
                    lastName={procedure?.details?.updated_by?.last_name}
                    profilePic={
                      procedure?.details?.updated_by?.profile_pic?.file_url
                    }
                    updatedAt={
                      procedure?.details?.updated_at
                        ? formateDateTime(procedure?.details?.updated_at)
                        : ""
                    }
                  />
                ) : (
                  ""
                )}
              </td>
            );
          } else if (
            singleHeader?.value === "approved" 
          ) {
            return (
              (procedure?.key === "procedure" && procedure?.children)? null : <td>
                {
                  !procedure?.children ? <div className="d-flex" style={{ gap: "5px",flexWrap:"wrap" }}>
                    {procedure?.details?.approver_details?.map((item: any) => {
                      return (
                        <CircularAvatar
                          name={`${item?.first_name} ${item?.last_name}`}
                          image={item?.profile_pic?.file_url}
                        />
                      );
                    })}

                    {(!isApproved && !isLocked && !!procedure?.details?.status) ? (
                      <div
                        className="pointer"
                        onClick={() =>
                          handleApprovalChange(procedure?._id, index)
                        }
                      >
                        <img
                          width={"25px"}
                          src={PlusIconCircle}
                          alt="plus icon circle"
                        />
                      </div>
                    ) : null}
                  </div> : null
                }
              </td>
            );
          } else if (
            singleHeader?.value === "attach_link" 
          ) {
            return (
              (procedure?.key === "procedure" && procedure?.children) ? null :  <td>
                {!procedure?.children ?
                  <div className="d-flex justify-content-center align-items-center">
                    {!isLocked ? <div
                      className="pointer"
                      style={{ paddingRight: "80px"}}
                      onClick={() =>
                        handleUploadSingleProcedureFile(index, procedure?._id)
                      }
                    >
                      <img src={UploadNewIcon} alt="upload" />
                    </div> : <div></div>}
                    <div
                      className="pointer"
                      onClick={() => handleFilePreviewData(index)}
                      style={{ position: "absolute", marginTop:isLocked ? "36px" : "none" }}
                    >
                      <PaperClipIcon />
                      {procedure?.details?.attachments?.length>0 ? <span
                        className="badge count-badge"
                        style={{ left: "11px" }}
                      >
                        {procedure?.details?.attachments?.length}
                      </span> : null}
                    </div>
                  </div> : null
                }
              </td>
            );
          }
        });

        return <tr>{finalRow}</tr>;
      })}
    </>
  );
};

export default AllOpenJobChecklistTableData;
